@if (_sidebarElement(); as sidebarElement) {
  <mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
    <mat-tab label="{{ 'Details' | transloco }}">
      <div class="sidebar-content">
        @if (renderDescription) {
          <div class="description">
            <label for="sidebar-content--description">{{ 'Content' | transloco }}:</label>
            <div class="description--wrapper">
              <common-rich-text-editor
                data-testid="sidebar-content_flowchart-textblock-content"
                id="sidebar-content--description"
                [disableImageUpload]="true"
                [displayTextWithoutColor]="true"
                [editorContent]="sidebarElement.content"
                [placePopupsToBottomLeft]="true"
                [placeholder]="FlowchartConfig.textBlockNode.placeholder | transloco"
                (editorContentChange)="onDescriptionChanged($event)" />
            </div>
          </div>
        }

        <mat-form-field appearance="outline" class="form-field">
          <label>{{ 'BorderStyle' | transloco }}:</label>
          <mat-select class="select" [(ngModel)]="borderStyle" (selectionChange)="onBorderStyleChange()">
            <mat-option class="select__option" value="solid">Solid ─────────</mat-option>
            <mat-option class="select__option" value="dashed">Dashed - - - - - - - - - - -</mat-option>
            <mat-option class="select__option" value="dotted">Dotted · · · · · · · · · · · ·</mat-option>
          </mat-select>
        </mat-form-field>

        <tt-color-picker [formControl]="borderColor" [label]="'BorderColor' | transloco" />

        <tt-color-picker [formControl]="backgroundColor" [label]="'BackgroundColor' | transloco" />

        <tt-divider class="tt-guideline-sidebar_divider" />

        <tt-guideline-component-sidebar-basics
          [attachments]="sidebarElement.attachments"
          [links]="sidebarElement.links"
          [references]="sidebarElement.references"
          [resourceTags]="sidebarElement.resourceTags"
          (basicsChanged)="handleBasicsChanged($event)" />
      </div>
    </mat-tab>
  </mat-tab-group>
}
